export default __webpack_public_path__ + "static/media/security03.1498bf75.png";